// initial state
import * as base from './base.js'
const smsLogName = '/admin/monitor/operlog'
const sysLogName = '/admin/monitor/logininfor'
const sysUpLogName = '/admin/api/sysUpLog'

const obj = base.setBaseUrl('smsLog', smsLogName)
const obj1 = base.setBaseUrl('sysLog', sysLogName)
const obj2 = base.setBaseUrl('sysUpLog', sysUpLogName)
const a = Object.assign(obj, obj1, obj2)
export default a
